/**
 * 与 session 工作站点（currentSiteId）绑定的桌面 / 手机后台路由。
 * 非列表内路径不展示「切换站点」，避免在站点管理、小程序管理等页误导用户。
 */

/** 精确匹配或以其为前缀（含子路径） */
const SITE_SCOPED_PREFIXES = [
  '/entries',
  '/settings',
  '/wechat',
  '/interfaces',
  '/wechat-official-push',
  '/robot-forward-logs',
  '/log-center',
  '/m/entries',
  '/m/register',
] as const;

function normalizePath(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  const trimmed = pathname.replace(/\/+$/, '') || '/';
  return trimmed;
}

export function isSiteScopedPath(pathname: string): boolean {
  const p = normalizePath(pathname);
  return SITE_SCOPED_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`));
}
